import { render, staticRenderFns } from "./Shoplist-filters.vue?vue&type=template&id=6db134ed&"
import script from "./Shoplist-filters.vue?vue&type=script&lang=js&"
export * from "./Shoplist-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports